import React from "react"
import { getPlatform } from "../Helpers"
import { PermissionsAndroid } from "./PermissionsAndroid"
import { PermissionsIOS } from "./PermissionsIOS"

function Permissions() {
    const platform = getPlatform()

    return (
        <>
            { platform === 'android' ? <PermissionsAndroid /> : <PermissionsIOS /> }
        </>
    )
}

export { Permissions }